module.exports = __webpack_public_path__ + "media/images/emblems/Bursinel-coat_of_arms-fba77a97b82caa73ed59822c08659d90.svg";